module.exports = __webpack_public_path__ + "static/assets/57d934dabfa95c4d5e066ebdaaaecbe4.svg";